import React, { useState } from "react";
import "./styles/Contact.css";
import ScrollToTopOnMount from "./utilities/ScrollToTopOnMount";
import Whatsapp from "../images/indice.png";
import { css } from "@emotion/core";


const Contact = () => {
  const [datos, setDatos] = useState({});

  const ingresarDatos = (e) => {
    console.log(e.target.value);
    setDatos({ ...datos, [e.target.name]: e.target.value });
  };

  return (
    <>
      <ScrollToTopOnMount />

      <div className="c-contact">
        <h4 className="resaltar">Contacto</h4>
        <p className="contact-message">
          ¡Por favor No dudes en enviarme un mensaje! Si estás interesado en
          ayudarme a trabajar proporcioname información como sea posible. Me
          pondré en contacto con usted lo antes posible. ¡Estoy a la espera!
        </p>
        <form
          className="formulario"
          name="contact"
          method="POST"
          data-netlify="true"
          action="/"
        >
          <input type="hidden" name="form-name" value="contact" />
          <label htmlFor="">Nombre</label>
          <input required name="name" onChange={ingresarDatos} type="text" />
          <label htmlFor="">Email</label>
          <input required name="email" onChange={ingresarDatos} type="email" />
          <label htmlFor="">Locacion</label>
          <input
            required
            name="location"
            onChange={ingresarDatos}
            type="text"
          />
          <label htmlFor="">Mensaje</label>
          <textarea
            required
            name="message"
            onChange={ingresarDatos}
            rows="10"
            cols="50"
            placeholder="Escribe algo aquí"
          ></textarea>
          <button type="submit" className="form-button">
            Enviar Mensaje
          </button>
        </form>

        <div className="whatsapp">
          <h2 className="display-2">O mándame un Whatsapp</h2>
          <img src={Whatsapp} alt="Link al whatsapp" />
            <a href="tel:9511212436">Contacto: 9511212436 (México)</a>
        </div>
      </div>
    </>
  );
};

export default Contact;
